import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  :root {
    --background: #121212; /* Fundo principal */
    --primary: #FFA500;   /* Cor de destaque */
    --text: #FFFFFF;      /* Texto principal */
    --text-secondary: #AAAAAA; /* Texto secundário */
  }

  body {
    margin: 0;
    padding: 0;
    font-family: 'Roboto', sans-serif;
    background-color: var(--background);
    color: var(--text);
  }
`;

export default GlobalStyle;
